import { useSnackbar } from 'notistack';
import { requestMediaUrl } from '../utils/requestMediaUrl';

function useDownloadFile(url: string): () => void {
    const { enqueueSnackbar } = useSnackbar();

    const downloadFile = async () => {
        try {
            await requestMediaUrl(url);
        } catch (e) {
            enqueueSnackbar('Could not download file', { variant: 'error' });
        }
    };

    return downloadFile;
}

export default useDownloadFile;
